
export enum CallType {
    SIP = "SIP",
    CLK2C = "CLK2C"
}
